import { Question } from "./QuestionTypes"
// ±

export const questions: Question[][] = [
	[
		{
			challenge: "What is the total annual compensation of the Prime Minister of Canada?",
			category: "local",
			choices: [
				{ option: "$188,800" },
				{ option: "$275,000" },
				{ option: "$367,200", correct: true },
				{ option: "$500,000" },
			],
		},
		{
			challenge: "Historically (1981-2010) what month has the most precipation in Terrace?",
			category: "local",
			choices: [
				{ option: "February", data: 110.6 },
				{ option: "April", data: 73.7 },
				{ option: "August", data: 61.2 },
				{ option: "October", data: 190.3, correct: true },
			],
			citation:
				"https://climate.weather.gc.ca/climate_normals/results_1981_2010_e.html?searchType=stnName&txtStationName=terrace&searchMethod=contains&txtCentralLatMin=0&txtCentralLatSec=0&txtCentralLongMin=0&txtCentralLongSec=0&stnID=441&dispBack=0",
			reveal: "climate.png",
		},
		{
			challenge: "What video games was Shigeru Miyamoto (宮本 茂) producer for?",
			content: "shigero-miyamoto.jpg",
			choices: [
				{ option: "Super Mario Bros. (NES)" },
				{ option: "The Legend of Zelda: Ocarina of Time (N64)" },
				{ option: "Pokemon Red/Blue (Gameboy)" },
				{ option: "All of the above", correct: true },
			],
			category: "games",
			citation: "https://en.wikipedia.org/wiki/Shigeru_Miyamoto_gameography",
		},
		{
			challenge: "When are the first trees believed to have evolved on earth?",
			choices: [
				{ option: "3,000,000,000 years ago" },
				{ option: "1,000,000,000 years ago" },
				{ option: "400,000,000 years ago", correct: true },
				{ option: "65,000,000 years ago" },
			],
			category: "life",
			citation: "https://www.sciencemag.org/news/2017/10/world-s-first-trees-grew-splitting-their-guts",
		},
		{
			challenge: "Which of these are NOT part of Billie Eilish's full legal name?",
			citation: "https://en.wikipedia.org/wiki/Billie_Eilish",
			choices: [
				{ option: "Billie" },
				{ option: "Caterpillar", correct: true },
				{ option: "O'Connell" },
				{ option: "Pirate" },
			],
			category: "music",
			content: "billie-eilish.jpg",
		},
		{
			challenge: "What is the best move? (white's turn)",
			category: "puzzle",
			choices: [{ option: "c5" }, { option: "h4+" }, { option: "Nxe6+" }, { option: "Qg7+", correct: true }],
			content: "chess1.png",
			reveal: "chess2.png",
			notransition: true,
			citation: "https://lichess.org/training/109279",
		},
		{
			challenge:
				"Canada is the second-largest country by total area, but it also has famously large lake coverage.  Which country is second by land area?",
			choices: [
				{ option: "Russia", data: 16_377_742 },
				{ option: "Canada", data: 9_093_507 },
				{ option: "China", data: 9_326_410, correct: true },
				{ option: "United States", data: 9_147_593 },
			],
			suffix: "km²",
			category: "world",
			citation: "https://en.wikipedia.org/wiki/List_of_countries_and_dependencies_by_area",
		},
		{
			challenge: "What was the most popular mobile app download of Q4 2019?",
			category: "tech",
			choices: [
				{ option: "Facebook", data: 175_000_000 },
				{ option: "Instagram", data: 120_000_000 },
				{ option: "TikTok", data: 220_000_000 },
				{ option: "WhatsApp", correct: true, data: 270_000_000 },
			],
			reveal: "app-downloads.png",
			citation: "https://go.sensortower.com/rs/351-RWH-315/images/Sensor-Tower-Q4-2019-Data-Digest.pdf?src=9to5mac",
		},
		{
			challenge: "What is skeuomorphism?",
			choices: [
				{ option: "Design that unnecessarily mimics physical reality", correct: true },
				{ option: "Design that avoids unnecessary parallels with phyiscal reality" },
				{ option: "Designs that can be adapted to dark and light themes" },
				{ option: "Designs that can be adapted to desktop and mobile form factors" },
			],
			category: "art",
			reveal: "skeuomorphism.jpg",
			citation: "https://www.interaction-design.org/literature/topics/skeuomorphism",
		},
		{
			challenge: "What is the world's largest company by market capitalization?",
			category: "industry",
			choices: [
				{ option: "Alphabet", data: 1_000_000_000_000 },
				{ option: "Amazon", data: 1_440_000_000_000 },
				{ option: "Apple", data: 1_580_000_000_000, correct: true },
				{ option: "Microsoft", data: 1_560_000_000_000 },
			],
			citation: "https://www.dogsofthedow.com/largest-companies-by-market-cap.htm",
		},
		{
			challenge:
				"According to the Canada 2016 Census, what percentage of the Kitimat-Stikine Regional District identifies as having North American Aboriginal origins?",
			choices: [{ option: "21.8%" }, { option: "28.7%" }, { option: "34.9%", correct: true }, { option: "40.2%" }],
			category: "local",
			citation:
				"https://www12.statcan.gc.ca/census-recensement/2016/dp-pd/prof/details/page.cfm?Lang=E&Geo1=CSD&Code1=5949011&Geo2=CD&Code2=5949&SearchText=Terrace&SearchType=Begins&SearchPR=01&B1=Ethnic%20origin&TABID=1&type=0#map-popup",
		},
		{
			challenge: "How many watts does a typical 100-watt equivalent LED lightbulb consume?",
			content: "lightbulb.png",
			choices: [
				{ option: "5 watts" },
				{ option: "15 watts", correct: true },
				{ option: "35 watts" },
				{ option: "60 watts" },
			],
			category: "science",
		},
		{
			challenge: "On what day did the NBA suspend the 2020 season due to COVID-19?",
			category: "games",
			choices: [
				{ option: "March 11", correct: true },
				{ option: "March 23" },
				{ option: "April 2" },
				{ option: "April 22" },
			],
			citation:
				"https://www.ctvnews.ca/sports/nba-suspends-season-after-utah-jazz-player-tests-positive-for-covid-19-1.4849502",
		},
		{
			challenge: "Which of these tech companies has the most employees?",
			category: "tech",
			choices: [
				// { option: "Apple", data: 137_000 },
				{ option: "Amazon", data: 840_400, correct: true },
				{ option: "Facebook", data: 44_942 },
				{ option: "Microsoft", data: 151_163 },
				{ option: "Netflix", data: 8_600 },
			],
		},
		{
			challenge: "If you bought $1000 of Bitcoin 5 years ago, what would it be worth now?",
			choices: [
				{ option: "$847.43" },
				{ option: "$2,850.02" },
				{ option: "$15,229.92" },
				{ option: "$40,250.25", correct: true },
			],
			category: "economics",
			citation: "https://coinmarketcap.com/currencies/bitcoin/historical-data/?start=20130428&end=20200703",
			reveal: "bitcoin.png",
		},
		{
			challenge: "Which triangle is larger?",
			category: "puzzle",
			content: "triangles.svg",
			choices: [
				{ option: "They are the same", correct: true },
				{ option: "Impossible to determine" },
				{ option: "Left" },
				{ option: "Right" },
			],
			citation: "https://brilliant.org/daily-problems/lattice-area/",
		},
		{
			challenge: "What is added to stainless steel to give it its corrosion resistant properties?",
			choices: [
				{ option: "Aluminum" },
				{ option: "Calcium" },
				{ option: "Chromium", correct: true },
				{ option: "Zinc" },
			],
			citation: "https://www.worldstainless.org/Files/issf/non-image-files/PDF/TheStainlessSteelFamily.pdf",
			category: "science",
			content: "steel-mill.jpg",
		},
		{
			category: "economics", // geography
			challenge:
				"According to the World Bank, which country had the highest poverty rate (< $5.50 USD/day income) in 2018?",
			choices: [
				{ option: "Honduras", data: 25 },
				{ option: "Indonesia", data: 21 },
				{ option: "Sierra Leone", data: 54, correct: true },
				{ option: "Ukraine", data: 1 },
			],
			percentage: true,
			citation: "https://data.worldbank.org/indicator/SI.POV.UMIC.GP",
		},
		{
			challenge: "What was the annual TFSA dollar limit for 2019?",
			category: "economics",
			choices: [
				{ option: "$5,000" },
				{ option: "$6,000", correct: true },
				{ option: "$7,500" },
				{ option: "$10,000" },
			],
		},
		{
			challenge:
				"Pick the film franchise with the largest total worldwide box office income (NOT inflation-adjusted)",
			choices: [
				{ option: "Jurassic Park", data: 5_009_038_251, correct: true },
				{ option: "Shrek", data: 3_545_629_858 },
				{ option: "Star Trek", data: 2_267_036_257 },
				{ option: "Twilight", data: 3_317_470_739 },
			],
			category: "film",
			citation: "https://www.the-numbers.com/movies/franchises/sort/World",
		},
	],
	[
		{
			challenge: "What is the model name of this pickup truck?",
			content: "cybertruck.jpg",
			reveal: "cybertruck-reveal.jpg",
			answer: "Tesla CyberTruck",
			category: "tech",
			notransition: true,
		},
		{
			challenge: 'What does the term "weeb" mean?',
			answer: "Anime/Japanese culture fanatic",
			citation: "https://www.urbandictionary.com/define.php?term=Weeb",
			category: "world",
			reveal: "sailor-moon.jpg",
		},
		{
			challenge: "What year (±1) did Blockbuster peak in number of stores worldwide?",
			category: "industry",
			answer: 2004,
			tolerance: 1,
			citation: "https://en.wikipedia.org/wiki/Blockbuster_LLC",
		},
		{
			challenge: "What does Ctrl+W do in most modern web browsers?",
			answer: "Close the current tab",
			category: "tech",
			citation: "https://support.google.com/chrome/answer/157179?hl=en",
		},
		{
			challenge: "Who are the two primary credit bureaus in Canada?",
			citation:
				"https://www.canada.ca/en/financial-consumer-agency/services/credit-reports-score/order-credit-report.html",
			category: "economics",
			answer: ["Equifax", "TransUnion"],
			reveal: "credit-bureaus.svg",
		},
		{
			challenge: "What country is this?",
			content: "sudan.svg",
			category: "world",
			answer: "Sudan",
			reveal: "sudan-flag.svg",
		},
		{
			challenge: "In what year did the #BlackLivesMatter movement start?",
			citation: "https://blacklivesmatter.com/six-years-strong/",
			answer: 2013,
			category: "world",
			content: "blm.webp",
		},
		{
			challenge:
				"What is the name of the supercontinent believed to have existed until approx. 175 million years ago?",
			answer: "Pangaea / Pangea",
			reveal: "pangaea.jpg",
			category: "world",
		},
		{
			challenge: "How many circles are needed to balance the bottom equation?",
			category: "puzzle",
			answer: "Two",
			content: "logic1.svg",
			reveal: "logic2.svg",
			citation: "https://brilliant.org/daily-problems/stable-squares/",
			notransition: true,
		},
		{
			challenge: "What is this flag called and when did Canada replace it as our national flag? (±2yr)",
			content: "canada-flag-old.svg",
			reveal: "canada-flag.svg",
			category: "local",
			answer: ["The Red Ensign", "1965 ±2"],
			citation:
				"https://www.canada.ca/en/canadian-heritage/services/flag-canada-history/timeline-national-flag.html",
		},
		{
			challenge: "What city is this?",
			category: "world",
			content: "miami.jpg",
			reveal: "miami.gif",
			answer: "Miami, FL",
			citation: "https://matadornetwork.com/destinations/north-america/united-states/miami/",
		},
		{
			challenge: "Who wrote Alice's Adventures in Wonderland, and when (±5yr)?",
			content: "alice-rabbit.png",
			answer: ["Lewis Carroll", "1865 ± 5"],
			category: "literature",
		},
		{
			challenge: "What is the full name of the upcoming Microsoft video game console",
			category: "games",
			reveal: "xbox.jpg",
			answer: "Xbox Series X",
			citation: "https://www.xbox.com/en-CA/consoles/xbox-series-x",
		},
		{
			challenge:
				"What year were the first women granted the right to vote in post-confederation Canadian federal elections? (±2yr)",
			category: "world",
			answer: "1917 (with exclusions)",
			citation: "https://thecanadianencyclopedia.ca/en/article/franchise",
		},
		{
			challenge:
				"Fertilizer is often designated with numbers like 24-8-16.  What ingredients do these numbers represent?",
			category: "science",
			answer: ["Nitrogen", "Phosphorus (phosphate)", "Potassium (potash)"],
			citation: "https://www.countryliving.com/gardening/a26093411/fertilizer-numbers/",
		},
		{
			challenge: "What is the largest automaker by market cap?",
			choices: [
				{ option: "General Motors", data: 49_000_000_000 },
				{ option: "Tesla", data: 102_000_000_000 },
				{ option: "Toyota", data: 202_000_000_000, correct: true },
				{ option: "Volkswagen", data: 96_000_000_000 },
			],
			category: "industry",
			reveal: "car-markets.jpg",
		},
		{
			challenge: "What is the official gemstone symbol of British Columbia?",
			answer: "Jade",
			citation: "https://www2.gov.bc.ca/gov/content/governments/celebrating-british-columbia/symbols-of-bc",
			category: "local",
			reveal: "jade.jpg",
		},
		{
			challenge: "What kind of fish is this? (order or species)",
			content: "angler-fish.jpg",
			answer: "Anglerfish",
			category: "life",
			citation: "https://en.wikipedia.org/wiki/Anglerfish",
			// citation:
			// 	"https://www.nytimes.com/2019/07/29/science/anglerfish-bioluminescence-deep-sea.html",
		},
		{
			challenge: "Who is this character?",
			category: "film",
			answer: "Genie from Aladdin",
			content: "aladdin.jpg",
			reveal: "aladdin.mp4",
		},
		{
			challenge: "In what city did Nikola Tesla reside throughout the majority of his career",
			category: "world",
			answer: "New York City",
			reveal: "tesla-corner.jpg",
			citation: "http://www.teslasociety.com/index.html",
		},
	],
	[
		{
			challenge: "Name the song and artist",
			category: "music",
			answer: ["Girl Crush", "Little Big Town"],
			content: "songs/girl-crush.mp4",
			reveal: "songs/girl-crush.jpg",
		},
		{
			challenge: "Name the song",
			category: "music",
			answer: "Gold (by Chet Faker)",
			content: "songs/gold.mp4",
			reveal: "songs/gold.jpg",
		},
		{
			challenge: "What music streaming service has the most paid subscribers?",
			category: "music",
			percentage: true,
			choices: [
				{ option: "Amazon Music", data: 15 },
				{ option: "Apple Music", data: 19 },
				{ option: "Spotify", data: 35, correct: true },
				{ option: "YouTube Premium", data: 6 },
			],
			reveal: "streaming-share.png",
		},
		{
			challenge: "Name the song and artist",
			category: "music",
			answer: ["Never Too Late", "Three Days Grace"],
			content: "songs/never-too-late.mp4",
			reveal: "songs/never-too-late.jpg",
		},
		{
			challenge: "Name the original song",
			category: "music",
			answer: "Blank Space",
			content: "songs/blank-space.mp4",
			citation: "https://www.youtube.com/watch?v=BtJST96WBm8",
		},
		{
			challenge: "Name the band",
			category: "music",
			content: "songs/street-light.mp4",
			reveal: "songs/street-light.jpg",
			answer: "Play Back",
		},
		{
			challenge: "Name the artist and their rival",
			category: "music",
			answer: ["Machine Gun Kelly", "Eminem"],
			content: "songs/rap-devil.mp4",
			reveal: "songs/rap-devil.jpg",
		},
		{
			challenge: "Name the song and the original artist",
			category: "music",
			content: "songs/sexy.mp4",
			answer: ["Sexy and I Know It", "LMFAO"],
			reveal: "songs/sexy.png",
		},
		{
			challenge: "Name the video game",
			category: "music",
			content: "songs/starcraft-terran.mp4",
			reveal: "songs/starcraft.jpg",
			answer: "StarCraft",
		},
		{
			challenge: "What percentage of music industry revenue is from digital streaming?",
			category: "music",
			choices: [{ option: "18%" }, { option: "30%" }, { option: "56%", correct: true }, { option: "72%" }],
			reveal: "music-revenue.png",
		},
		{
			challenge: "What was the name of Liam Neeson's character?",
			category: "film",
			answer: "Ra's al Ghul (aka Henri Ducard)",
			content: "film/batman-begins.mp4",
			reveal: "film/batman-begins2.mp4",
		},
		{
			challenge: "Name the movie",
			category: "film",
			content: "film/akira.mp4",
			reveal: "film/akira.jpg",
			answer: "Akira (1988)",
		},
		{
			challenge: "Name the movie and the actor",
			category: "film",
			content: "film/dead-poets-society.mp4",
			reveal: "film/dead-poets-society.jpg",
			answer: ["Dead Poets Society (1989)", "Robert Sean Leonard"],
		},
		{
			challenge: "Name the movie",
			category: "film",
			answer: "Blade Runner 2049 (2017)",
			content: "film/bladerunner1.mp4",
			reveal: "film/bladerunner.jpg",
		},
		{
			challenge: "What is the largest source of video traffic online?",
			category: "film",
			choices: [
				{ option: "Facebook", data: 3.0 },
				{ option: "BitTorrent", data: 2.4 },
				{ option: "Netflix", data: 12.8, correct: true },
				{ option: "YouTube", data: 8.7 },
			],
			percentage: true,
			citation: "https://www.sandvine.com/inthenews/netflix-falls-to-second-place-in-global-internet-traffic-share",
		},
		{
			challenge: "Name the movie",
			category: "film",
			content: "film/hot-fuzz.mp4",
			reveal: "film/hot-fuzz.jpg",
			answer: "Hot Fuzz (2007)",
		},
		{
			challenge: "Name the movie",
			category: "film",
			content: "film/gattaca.mp4",
			reveal: "film/gattaca.jpg",
			answer: "Gattaca (1997)",
		},
		{
			challenge: "Name the movie",
			category: "film",
			content: "film/meatballs.mp4",
			reveal: "film/meatballs.webp",
			answer: "Meatballs (1979)",
		},
		{
			challenge: "Name this actor",
			content: "donnie-yen.jpg",
			answer: "Donnie Yen (甄子丹)",
			citation: "https://en.wikipedia.org/wiki/Donnie_Yen",
			category: "film",
			reveal: "ipman3.mp4", // TODO clip video
		},
		{
			challenge: "Name the movie",
			category: "film",
			content: "film/office-space.mp4",
			reveal: "film/office-space.jpg",
			answer: "Office Space (1999)",
		},
	],
]
